import { useContext } from 'react'
import { OverviewWidgetContext, FindMemberContext, ToggleContext } from '@typesApp/WidgetContextHolder'
import { WidgetContext } from './context'

export const useToggleWidgetContext = (): ToggleContext | undefined => {
  const context = useContext(WidgetContext)
  return context.toggle
}

export const useOverviewWidgetContext = (): OverviewWidgetContext | undefined => {
  const context = useContext(WidgetContext)
  return context.overviewWidget
}

export const useFindMemberContext = (): FindMemberContext | undefined => {
  const context = useContext(WidgetContext)
  return context.findMember
}
